import clsx from 'clsx'
import noop from 'lodash/noop'
import toNumber from 'lodash/toNumber'
import React, { FC, useMemo, useRef } from 'react'

import styles from './MultiRangeInput.module.scss'

export interface MultiRangeInputProps {
  disabled?: boolean
  from: number | string
  fromChanged?: (from: number) => void
  maxLimit: number
  minLimit: number
  onActive?: () => void
  onBlur?: () => void
  to: number | string
  toChanged?: (to: number) => void
}

export const MultiRangeInput: FC<MultiRangeInputProps> = ({
  disabled,
  maxLimit,
  minLimit,
  toChanged = noop,
  onActive = noop,
  fromChanged = noop,
  from = minLimit,
  to = maxLimit,
  onBlur = noop,
}) => {
  const fromRef = useRef<HTMLInputElement | null>(null)
  const toRef = useRef<HTMLInputElement | null>(null)
  const fromValue = useMemo(
    () => toNumber(fromRef.current?.value),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [fromRef.current?.value],
  )
  const toValue = useMemo(
    () => toNumber(toRef.current?.value),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [toRef.current?.value],
  )

  return (
    <div className={styles.multiRangeSlider}>
      <input
        className={clsx(styles.minInput, disabled && styles.disabled)}
        max={maxLimit}
        min={minLimit}
        onChange={(e) => {
          if (disabled) {
            return
          }
          const value = toNumber(e.target.value)
          const maxL = toValue - 1
          if (fromRef.current && value > maxL) {
            fromRef.current!.value = maxL.toString()
            return
          }
          fromChanged(value)
        }}
        onMouseDown={onActive}
        onMouseUp={onBlur}
        onTouchEnd={onBlur}
        onTouchStart={onActive}
        ref={fromRef}
        type="range"
        value={from}

      />
      <input
        className={clsx(styles.maxInput, disabled && styles.disabled)}
        max={maxLimit}
        min={minLimit}
        onChange={(e) => {
          if (disabled) {
            return
          }
          const value = toNumber(e.target.value)
          const minL: number = fromValue + 1
          if (toRef.current && value < minL) {
            toRef.current!.value = minL.toString()
            return
          }
          toChanged(value)
        }}
        onMouseDown={onActive}
        onMouseUp={onBlur}
        onTouchEnd={onBlur}
        onTouchStart={onActive}
        ref={toRef}
        type="range"
        value={to}
      />
      <div className={styles.line} />
      <div
        className={styles.markLine}
        style={{
          marginLeft: `calc((100% / ${maxLimit} * ${from}) + 5px)`,
          marginRight: `calc((100% - (100% / ${maxLimit} * ${to})) + 5px)`,
        }}
      />
    </div>
  )
}
